import React from "react"
import "./LoginForm.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons"

function SignupForm({
  loginToSignup,
  ChangeHandlerRegister,
  register,
  registerInfo,
  registerErrorMsg,
}) {
  const renderErrorMsg = (registerErrorMsg, field) => {
    if (registerErrorMsg?.[field] != undefined) {
      return (
        <p className='error-message'>
          <FontAwesomeIcon icon={faExclamationCircle} />
          {registerErrorMsg.[field]}
        </p>
      )
    }
  }

  return (
    <div className='boxContainer'>
      <form className='formContainer'>
        <input
          className='inputForm'
          type='text'
          placeholder='First Name'
          name='first_name'
          onChange={ChangeHandlerRegister}
          value={registerInfo.first_name}
        />
        {renderErrorMsg(registerErrorMsg, "first_name")}
        <input
          className='inputForm'
          type='text'
          placeholder='Last Name'
          name='last_name'
          onChange={ChangeHandlerRegister}
          value={registerInfo.last_name}
        />
        {renderErrorMsg(registerErrorMsg, "last_name")}
        <input
          className='inputForm'
          type='email'
          placeholder='Email'
          name='email'
          onChange={ChangeHandlerRegister}
          value={registerInfo.email}
        />
        {renderErrorMsg(registerErrorMsg, "email")}
        <input
          className='inputForm'
          type='password'
          placeholder='Password'
          name='password'
          onChange={ChangeHandlerRegister}
          value={registerInfo.password}
        />
        {renderErrorMsg(registerErrorMsg, "password")}
        <input
          className='inputForm'
          type='password'
          placeholder='Password Confirmation'
          name='password_confirm'
          onChange={ChangeHandlerRegister}
          value={registerInfo.password_confirm}
        />
        {renderErrorMsg(registerErrorMsg, "password_confirm")}
        <button
          className='submitButton'
          onClick={(e) => {
            e.preventDefault()
            register()
          }}>
          {" "}
          Sign In
        </button>
        <p className='mutedLink'>
          Already have an account?{" "}
          <button
            className='boldBtn'
            onClick={(e) => {
              loginToSignup()
            }}>
            Login
          </button>
        </p>
      </form>
    </div>
  )
}

export default SignupForm
